import { render, staticRenderFns } from "./FileManagerEditDocumentComponent.vue?vue&type=template&id=707a90b5&scoped=true&lang=pug"
import script from "./FileManagerEditDocumentComponent.vue?vue&type=script&lang=ts"
export * from "./FileManagerEditDocumentComponent.vue?vue&type=script&lang=ts"
import style0 from "./FileManagerEditDocumentComponent.vue?vue&type=style&index=0&id=707a90b5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707a90b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('707a90b5')) {
      api.createRecord('707a90b5', component.options)
    } else {
      api.reload('707a90b5', component.options)
    }
    module.hot.accept("./FileManagerEditDocumentComponent.vue?vue&type=template&id=707a90b5&scoped=true&lang=pug", function () {
      api.rerender('707a90b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FileManager/FileManagerEditDocumentComponent.vue"
export default component.exports